import ProlongCampaignModal from './ProlongCampaignModal.component';

export default ProlongCampaignModal;
